import { MachineLockedParams } from "./api";
import { CreateElement, Scale, SetStyles } from "./MyHelpers";
import { ImageResource } from "./ResourceManager/ImageResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { ScreenLoadFinishedMessage } from "./ScreenProtocol";
import { ZIndex } from "./ZIndex";



export interface LockEvent
{

}

export class Lock implements Resourceful
{
	private resourcesBasePath: string;
	private view: HTMLElement = null;
	private dialog: HTMLElement = null;
	private resid: ResourceIdentifier = null;

	private titleContainer: HTMLElement = null;
	private reasonContainer: HTMLElement = null;
	protected isLocked:boolean = false;

	public constructor(resid: ResourceIdentifier, resourcesBasePath: string)
	{
		this.resid = resid.Add("Lock");
		this.resourcesBasePath = resourcesBasePath;

		this.view = CreateElement("div", {
			classes: [this.resid.Scope()],
		});

		SetStyles(this.view, 
		{
			position: "absolute",
			top: "0px",
			left: "0px",
			height: "100%",
			width: "100%",
			backgroundColor: "rgba(0, 0, 0, 0.8)",
			color: "white",
			
			display: "flex",
			flexDirection: "column",
		  	alignItems: "center",
			justifyContent: "center",
			zIndex: ""+ ZIndex.Lock,
		});

		this.dialog = CreateElement("div", {
			classes: [this.resid.Add("dialog").Scope()],
			style: {
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
	
				// width: "50%",
				// height: "50%",
				backgroundColor: "black",
				color: "white",
				borderRadius: Scale.XYpx(50),
				padding: Scale.XYpx(25),
			}
		});


		this.titleContainer = CreateElement("div", {
			classes: [this.resid.Add("title").Scope()],
			style: {
				fontSize: Scale.fhpx(100),
				lineHeight: Scale.fhpx(100),
			},
			innerHTML: "MACHINE LOCKED"
		})

		this.reasonContainer = CreateElement("div", {
			classes: [this.resid.Add("reason").Scope()],
			style: {
				fontSize: Scale.fhpx(50),
				lineHeight: Scale.fhpx(50),
				textAlign: "center"
			},
			innerHTML: ""
		});

		this.Hide();
	}

	public PrepareResources(resourceManager: IWriteOnlyResourceManager): void
	{
		resourceManager.Add(new ImageResource(this.resourcesBasePath + "img/lock.png", this.resid.ScopedResourceName("lock")));
	}

	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager): void
	{
		this.dialog.appendChild(this.titleContainer);
		let img = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("lock")).img;
		SetStyles(img, {
			width: Scale.Wpx(192),
			height: Scale.Hpx(256)
		});
		this.dialog.appendChild(img);
		this.dialog.appendChild(this.reasonContainer);

		this.view.appendChild(this.dialog);
	}

	public Start(lockParams: MachineLockedParams)
	{
		let locksText = lockParams.LockEvents.slice(-5).map(l => `${l.EventCode} - ${l.EventId}`).join("<br />");

		if (lockParams.LockEvents.length > 5)
		{
			locksText += `<br />${lockParams.LockEvents.length - 5} more`;
		}

		this.reasonContainer.innerHTML = locksText;
		this.Show();
		this.isLocked = true;
	}

	public StartFrontend(code: string, eventid: string)
	{
		this.reasonContainer.innerHTML = `${code} - (${eventid})`;
	}

	public Stop()
	{
		this.Hide();
		this.isLocked = false;
	}

	public IsLocked():boolean
	{
		return this.isLocked;
	}

	protected Show()
	{
		this.view.style.visibility = "visible";
	}

	protected Hide()
	{
		this.view.style.visibility = "hidden";
	}

	public View(): HTMLElement
	{
		return this.view;
	}
}